import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import XYZ from 'ol/source/XYZ';
import { ImageWMS, TileArcGISRest } from 'ol/source';
import { OSM, Vector } from 'ol/source';
import * as Proj from 'ol/proj';
import { defaults as defaultControls, Control } from 'ol/control';
import { Overlay, Feature, MapBrowserEvent } from 'ol';
import { toStringHDMS, Coordinate } from 'ol/coordinate';
import Polygon from 'ol/geom/Polygon';
import { Circle as CircleStyle, Icon, Style, Text } from 'ol/style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import VectorSource from 'ol/source/Vector';
import { EsriJSON} from 'ol/format';

import { GeoJSON } from 'ol/format';
import MultiPoint from 'ol/geom/MultiPoint';

import { applyTransform, coordinateRelationship } from 'ol/extent';
import { get as getProjection, getTransform } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import { environment } from 'src/environments/environment';
import { BarrioModel } from 'src/app/core/models/barrio.model';
import { SubBarrioModel } from 'src/app/core/models/sub-barrio.model';
import { OcupacionZonaModel } from 'src/app/core/models/ocupacion-zona.model';
import TileSource from 'ol/source/Tile';
import { PlazaModel } from 'src/app/core/models/plaza.model';
import Point from 'ol/geom/Point';
import { RegulacionPlazaModel } from 'src/app/core/models/regulacion-plaza.model';

const DEFAULT_HEIGHT = '500px';
const DEFAULT_WIDTH = '500px';

const DEFAULT_LAT = 41.65518;
const DEFAULT_LON = -4.72372;

@Component({
  selector: 'ol-map',
  templateUrl: './ol-map.component.html',
  styleUrls: ['./ol-map.component.css'],
})
export class OlMapComponent implements OnInit, AfterViewInit {
  @Input() lat?: number = DEFAULT_LAT;
  @Input() lon?: number = DEFAULT_LON;
  @Input() zoom?: number = 14;
  @Input() width?: string | number = DEFAULT_WIDTH;
  @Input() height?: string | number = DEFAULT_HEIGHT;
  @Input() loadBarrios?: boolean = false;
  @Input() subBarrios?: OcupacionZonaModel[] = [];

  subBarrioSelected: OcupacionZonaModel;
  target: string = 'map-' + Math.random().toString(36).substring(2);
  map: Map;
  overlayPopUp: Overlay;
  containerPopUp;
  contentPopup;
  green = 'green';
  red = 'red';
  private mapEl: HTMLElement;

  constructor(private elementRef: ElementRef) {
    proj4.defs(
      'EPSG:25830',
      '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
    );
    register(proj4);
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.containerPopUp = document.getElementById('popup');
    this.contentPopup = document.getElementById('popup-content');
    this.mapEl = this.elementRef.nativeElement.querySelector('#' + this.target);
    this.setSize();
    this.overlayPopUp = new Overlay({
      element: this.containerPopUp,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    this.map = new Map({
      target: this.target,
      layers: [
        new TileLayer({
          /*source: new VectorSource({
            format: new EsriJSON(),
            url: 'https://www10.ava.es/arcgisva/rest/services/CallejeroVA/
                  PlanoMovilidad_Base/MapServer/20/query?where=OBJECTID > 0&text=
                  &objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope
                  &inSR=&spatialRel=esriSpatialRelIntersects&relationParam=
                  &outFields=*&returnGeometry=true&returnTrueCurves=false
                  &maxAllowableOffset=&geometryPrecision=&outSR=&having=
                  &returnIdsOnly=false&returnCountOnly=false&orderByFields
                  =&groupByFieldsForStatistics=&outStatistics=
                  &returnZ=false&returnM=false&gdbVersion=
                  &historicMoment=&returnDistinctValues=false
                  &resultOffset=&resultRecordCount=&queryByDistance=
                  &returnExtentOnly=false&datumTransformation=
                  &parameterValues=&rangeValues=&quantizationParameters=&f=pjson'
           }),*/
          // source: new OSM(),
         // source: new XYZ({url: 'https://www10.ava.es/arcgisva/rest/services/CallejeroVA/base/MapServer?f=json'}),
          source: new XYZ({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
              'rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/ArcGIS/rest/services/' +
              'World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
          }),
        }),
      ],
      overlays: [this.overlayPopUp],
      view: new View({
        projection: getProjection('EPSG:3857'),
        center: Proj.fromLonLat([this.lon, this.lat]),
        zoom: this.zoom,
        maxZoom: 19
      }),
      controls: defaultControls({ attribution: false, zoom: false }).extend([]),
    });

    /**
     * JCRB Carga de la capa y establecimiento de evento
     */
    if (this.loadBarrios) {
      const EsriBarriosLayer = this.getBarriosLayer();
      this.map.addLayer(EsriBarriosLayer);
      this.setClickEvent();
    }


  }

  private setSize() {
    if (this.mapEl) {
      const styles = this.mapEl.style;
      styles.height = coerceCssPixelValue(this.height) || DEFAULT_HEIGHT;
      styles.width = coerceCssPixelValue(this.width) || DEFAULT_WIDTH;
    }
  }

  public setMarker(vector: VectorLayer) {
    this.map.addLayer(vector);
  }

  public setControl(control: Control) {
    this.map.addControl(control);
  }

  public setOverlay(overlay: Overlay) {
    this.map.addOverlay(overlay);
  }

  private getBarriosLayer() {
       const styles = [
      new Style({
        geometry: (feature: Feature) => {
              const nombreSubBarrio: string = feature.get('NOMBRE_SUB');
              const color = this.getColorFeatureBarrio(feature.get('NOMBRE_BAR'));
              feature.setStyle(new Style({
                                stroke: new Stroke({
                                  color: 'rgb(' + color + ')',
                                  width: 1,
                                }),
                                fill: new Fill({
                                  color: 'rgba(' + color + ', 0.2)',
                                }),
                                text: new Text({
                                  font: ' bold 15px Calibri,sans-serif',
                                  fill: new Fill({ color: '#000' }),
                                  stroke: new Stroke({
                                    color: '#fff', width: 2
                                  }),
                                  text: nombreSubBarrio.toLocaleUpperCase()
                                })
                              }
              ));
              return null;
        },
      })];
       const source = new VectorSource({
        format: new EsriJSON(),
        url: environment.capa_barrios
       });

       return new VectorLayer({
      extent: this.map.getView().calculateExtent(),
      source,
      style: styles,
    });
  }

  private displayBarrioInfo = (evt: MapBrowserEvent ) => {
    const features = [];
    this.subBarrioSelected = undefined;
    this.map.forEachFeatureAtPixel(evt.pixel, (feature) => {
      if (feature.get('NOMBRE_BAR') !== 'EXTRARRADIO') {
        features.push(feature);
      }
    });
    const info = [];
    if (features.length > 0) {
    features.forEach((feature) => {
      this.subBarrios.forEach((subBarrio) => {
        if (subBarrio.idSubBarrioEsri === feature.get('OBJECTID')) {
          this.subBarrioSelected = subBarrio;
          info.push(`${subBarrio.nombre}<br/>`);
          info.push(`Plazas totales : ${subBarrio.plazasTotales}<br/>`);
          info.push(`Plazas ocupadas : ${subBarrio.plazasTotales - subBarrio.plazasDisponible}<br/>`);
          info.push(`Plazas disponibles : ${subBarrio.plazasDisponible}`);
        }
      });
    }
      // info.push(`${feature.get('OBJECTID')} - ${feature.get('NOMBRE_SUB')}`)
    );
    this.overlayPopUp.setPosition(evt.coordinate);
  } else {
    this.overlayPopUp.setPosition(undefined);
  }
   // this.contentPopup.innerHTML = info.join('');

  }

  private setClickEvent() {
    this.map.on('click', (evt) => {
      this.displayBarrioInfo(evt);
    });
  }

  closePopUp() {
    this.overlayPopUp.setPosition(undefined);
    return false;
  }

  getColorFeatureBarrio(cod: string) {
    switch (cod) {
      case 'LA OVERUELA': return '221, 82, 70';
      case 'EL BERROCAL': return '254, 207, 74';
      case 'LA VICTORIA': return '221, 82, 70';
      case 'BARRIO ESPAÑA': return '255, 102, 255';
      case 'SAN PEDRO REGALADO': return '255, 255, 51';
      case 'RONDILLA': return '51, 255, 255';
      case 'HOSPITAL': return '204, 102, 51';
      case 'BATALLAS': return '255, 102, 0';
      case 'BELEN - PILARICA': return '204, 153, 153';
      case '10': return '0, 255, 51';
      case 'PILARICA - LOS SANTOS': return '255, 204, 255';
      case 'HUERTA DEL REY': return '0, 255, 204';
      case 'SAN PABLO - SAN NICOLAS': return '204, 204, 51';
      case 'LA ANTIGUA - SANTA CRUZ': return '51, 204, 255';
      case 'VADILLOS': return '153, 102, 255';
      case 'PAJARILLOS BAJOS': return '102, 204, 255';
      case 'PAJARILLOS ALTOS': return '0, 204, 255';
      case 'LAS FLORES': return '255, 255, 51';
      case 'PLAZA MAYOR': return '255, 153, 255';
      case 'PLAZA ESPAÑA': return '51, 204, 102';
      case 'CIRCULAR': return '153, 0, 0';
      case 'CAMPO GRANDE': return '102, 153, 255';
      case 'CAÑO ARGALES': return '153, 0, 153';
      case 'DELICIAS - ARCO DE LADRILLO': return '255, 0, 204';
      case 'DELICIAS - CANTERAC': return '102, 204, 0';
      case 'PARQUESOL': return '255, 0, 51';
      case 'ARTURO EYRIES': return '102, 204, 0';
      case 'PLAZA DE TOROS': return '102, 0, 153';
      case 'CUATRO DE MARZO': return '102, 153, 204';
      case 'LA FAROLA': return '204, 204, 51';
      case 'POLIGONO ARGALES': return '153, 51, 0';
      case 'POLIGONO SAN CRISTOBAL': return '204, 204, 51';
      case 'LAS VILLAS - VALPARAISO': return '255, 102, 204';
      case 'LA RUBIA': return '255, 153, 51';
      case 'PARQUE ALAMEDA - PAULA LOPEZ': return '102, 153, 255';
      case 'COVARESA': return '255, 255, 0';
      case 'EL PINAR': return '';
      case 'PUENTE DUERO': return '';
      case 'SOTO DE MEDINILLA': return '35, 168, 242';
      case 'SAN MARTIN': return '255, 204, 0';
      case 'SAN ISIDRO': return '204, 153, 0';
      default : return '104, 118, 125';
    }
  }
}

const cssUnitsPattern = /([A-Za-z%]+)$/;

function coerceCssPixelValue(value: any): string {
  if (value == null) {
    return '';
  }

  return cssUnitsPattern.test(value) ? value : `${value}px`;
}
